module.exports = __webpack_public_path__ + "static/media/18.1ff7932d.jpg";